import axios, { AxiosResponse } from "axios";
import { Profile } from "../Models/Profile";
import { UserStore } from "../stores/useProfile";
import { Set } from "../Models/Set";
import { LoginDto } from "../Models/Types";
import { SERVERURL } from "../Globals/Constants";

export const getProfile = async (set: Set<UserStore>, loginData: LoginDto) => {
  try {
    const response: AxiosResponse = await axios.post<Profile>(
      `${SERVERURL}/api/user/login`,
      loginData,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    set((state) => ({ ...state, user: response.data }));
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};
